import React from "react";

function Shipping() {
  return (
    <>
      <h1>Shipping & Delivery Policy</h1>
      <h6>Last updated on Jul 6th 2023</h6>
      <p>Shipping is not applicable for business.</p>
    </>
  );
}

export default Shipping;
